var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.mapsMode && _vm.selectedRelease
    ? _c(
        "div",
        {
          staticClass:
            "d-flex flex-column justify-content-center align-items-center",
          staticStyle: { gap: "5px" },
        },
        [
          _vm.mapsMode
            ? _c("DT_LatLong", {
                attrs: {
                  map: _vm.map,
                  mapsMode: _vm.mapsMode,
                  clickedCoords: _vm.clickedCoords,
                },
                on: {
                  addPoint: function ($event) {
                    return _vm.$emit("addPoint", $event)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showMeasuringTool
            ? _c("DT_Measurement", {
                attrs: {
                  showSnippingTool: _vm.showSnippingTool,
                  showMeasuringTool: _vm.showMeasuringTool,
                  measurement: _vm.measurement,
                  polygonsSelected: _vm.polygonsSelected,
                  user: _vm.user,
                  selectedExtent: _vm.selectedExtent,
                  polygonVectorLayersLength: _vm.polygonVectorLayers.length,
                },
                on: {
                  clearPolygon: function ($event) {
                    return _vm.$emit("clearPolygon")
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          parseInt(_vm.polygonVectorLayers.length) > 0 && !_vm.lidarFlag
            ? _c("DD_PolygonButtons", {
                attrs: {
                  polygonsSelected: _vm.polygonsSelected,
                  user: _vm.user,
                  selectedExtent: _vm.selectedExtent,
                  polygonVectorLayersLength: _vm.polygonVectorLayers.length,
                },
                on: {
                  clearPolygon: function ($event) {
                    return _vm.$emit("clearPolygon")
                  },
                  notification: function ($event) {
                    return _vm.$emit("notification", $event)
                  },
                  "admin-notification": function ($event) {
                    return _vm.$emit("admin-notification", $event)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showLidarPanel
            ? _c("DT_LidarTiles", {
                attrs: {
                  lidarMinZoomAchieved: _vm.lidarMinZoomAchieved,
                  showLidarPanel: _vm.showLidarPanel,
                  distinct_lidar: _vm.distinct_lidar,
                  extentName: _vm.selectedExtent,
                  lidarIsLoading: _vm.lidarIsLoading,
                  map: _vm.map,
                  selectedExtent: _vm.selectedExtent,
                  zoomLevel: _vm.zoomLevel,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.lidarTrailsActive
            ? _c(
                "div",
                { staticClass: "year-filter-anchor" },
                [
                  _c("TRT_YearFilter", {
                    on: {
                      yearFilterChanged: function ($event) {
                        return _vm.$emit("yearFilterChanged", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }